import mvtDialog from '@/common/components/mvtdialog/mvt-dialog.vue';
import loadDialogError from '@/common/components/mvtdialogcenter/loaddialogerror.vue';
import loadingDialog from '@/common/components/mvtdialogcenter/loadingdialog.vue';
import { mapGetters, mapActions, mapMutations } from 'vuex';
import { loadAppleAuth } from '@/common/utilities/nojq/_load.auth.js';
import { lazyDeps } from '../../utilities/lazy-deps.js';

const { ref: _ga4 } = lazyDeps(
    () => import(/* webpackChunkName: "gtm-deps" */ '../../../../widget/spec/ga4helper'),
    (m) => ({ getGa4Trigger: m.getGa4Trigger })
);
function getGa4Trigger(...args) { return _ga4.getGa4Trigger ? _ga4.getGa4Trigger(...args) : args[0]; }
let _ojolink = null;
const getOjolink = () => _ojolink || (_ojolink = import(/* webpackChunkName: "ojolink" */ '@/common/utilities/nojq/_load.ojolink.js'));
import { setStorage, getStorage } from '../../utilities/nojq/_localstorage.js';
var timer = null;
var tipTimer = null;
export default {
    name: 'mvtDialogCenter',
    inject: ['$eventBus'],
    components: {
        mvtDialog,
        loadDialogError,
        loadingDialog,
    },
    data() {
        return {
            message: '',
            showTip: false,
            isNewStyle: false,
            componentName: '',
            componentOpt: {
                type: '',
            },
            componentTemplate: '',
            componentTrigger: '',
            initalApple: false,
            dialogCache: {},
            dlgRetryCount: 0,
            requestName: '',
            componentMounted: false,
        };
    },
    computed: {
        ...mapGetters('glb', ['glb', 'getSplit', 'getPrevHotlead', 'getErrorHtml', 'removeAds']),
        ...mapGetters('dpp', ['dpp']),
    },
    methods: {
        ...mapActions('glb', ['loginForGoogleAccount', 'loginForAppleAccount', 'signup', 'checkUserByEmailId']),
        ...mapMutations('glb', ['resetPrevHotlead']),
        signUpMixin(userEmail, requestName, phone, name) {
            this.requestName = requestName;
            this.glb.authFormState = 'submitting';

            this.checkUserByEmailId({
                email: userEmail,
            })
                .then((res) => {
                    let status = res && res.status;
                    if (status.code === 0 && res.data.id) {
                        this.glb.authErrorMessage = '';
                        this.glb.authFormState = '';
                        if (res.data.googleConnected) {
                            this.$eventBus.$emit('dialog-center', {
                                name: 'mvtAuthenticate',
                                opt: {
                                    type: 'mvtWelcomeBack',
                                    email: userEmail,
                                    loginType: 'google',
                                    loginMessage: 'You signed up with your Google account',
                                    requestName: requestName,
                                    trigger: this.componentTrigger,
                                },
                                trigger: this.componentTrigger,
                            });
                        } else if (res.data.appleConnected) {
                            this.$eventBus.$emit('dialog-center', {
                                name: 'mvtAuthenticate',
                                opt: {
                                    type: 'mvtWelcomeBack',
                                    email: userEmail,
                                    loginType: 'apple',
                                    loginMessage: 'You originally signed up with Apple',
                                    requestName: requestName,
                                    trigger: this.componentTrigger,
                                },
                                trigger: this.componentTrigger,
                            });
                        } else {
                            this.$eventBus.$emit('dialog-center', {
                                name: 'mvtAuthenticate',
                                opt: {
                                    type: 'mvtEmailLogin',
                                    loginType: 'email',
                                    email: userEmail,
                                    isUserExist: true,
                                    activated: res.data.activated === true,
                                    requestName: requestName,
                                    phone: phone,
                                    name: name,
                                },
                                trigger: this.componentTrigger,
                            });
                        }
                    } else {
                        this.signUp(userEmail, requestName, phone, name);
                    }
                })
                .catch((err) => {
                    this.glb.authFormState = '';
                });
        },
        signUp(userEmail, requestName, phone, name) {
            const isSellerPage = ['vsell', 'vsellfast', 'vhomeWorth', 'vhomesalecalc', 'vhomeowner', 'vhomeserviceslanding'].includes(this.glb.pageType);
            const userType = isSellerPage ? 'seller' : this.glb.pageInfo.userType;

            this.glb.authFormState = 'submitting';

            this.signup({
                email: userEmail,
                userByEmail: true,
                phone: phone,
                firstName: name,
                userType,
                trigger: getGa4Trigger(this.componentTrigger, requestName),
            })
                .then((resp) => {
                    let status2 = resp && resp.status;
                    if (status2 && status2.code === 0) {
                        this.glb.authFormState = 'submitted';
                        this.glb.authErrorMessage = '';
                        this.$eventBus.$emit('eventbus-authenticated', requestName);
                    } else {
                        this.glb.authFormState = 'rejected';
                        this.glb.authErrorMessage = this.getErrorHtml(status2);
                    }
                })
                .catch((err) => {
                    this.glb.authFormState = '';
                    this.glb.authErrorMessage = '';
                });
        },
        afterLoginAndCloseDialog() {
            if (timer) {
                clearTimeout(timer);
            }
            let hasDialog = $('#body').hasClass('dialog-active') || $('#body').hasClass('popownup-active');
            if (hasDialog) {
                this.$eventBus.$once('eventbus-dialog-close', () => {
                    timer = setTimeout(() => {
                        this.afterLoginAndCloseDialog();
                    }, 2000);
                });
            } else {
                setTimeout(
                    () => {
                        clearTimeout(timer);
                        this.dialogAllClosed();
                    },
                    timer ? 1000 - timer : 3000
                );
            }
        },
        getDialog(name) {
            let loader, callback;
            switch (name) {
                case 'mvtSearchResult':
                    loader = import(/* webpackChunkName: "dlg.tpls.searchresult" */ '@/common/components/mvtsearchresult/mvt-searchresult.vue');
                    break;
                case 'mvtGeoSearchResult':
                    loader = import(/* webpackChunkName: "dlg.tpls.geosearchresult" */ '@/common/components/mvtgeosearchresult/mvt-geosearchresult.vue');
                    break;
                case 'mvtAuthenticate':
                    loader = import(/* webpackChunkName: "dlg.tpls.authenticate" */ '@/common/components/mvtauthenticate/mvt-authenticate.vue');
                    break;
                case 'mvtHotleadForm':
                    loader = import(/* webpackChunkName: "dlg.tpls.hotleadform" */ '@/common/components/mvthotleadform/mvt-hotleadform.vue');
                    break;
                case 'mvtConfirm':
                    loader = import(/* webpackChunkName: "dlg.tpls.confirm" */ '@/common/components/mvtconfirm/mvt-confirm.vue');
                    break;
                case 'mvtConfirmAuth':
                    loader = import(/* webpackChunkName: "dlg.tpls.confirmauth" */ '@/common/components/mvtconfirm/mvt-confirmauth.vue');
                    break;
                case 'mvtMortgageForm':
                    loader = import(/* webpackChunkName: "dlg.tpls.mortgageform" */ '@/common/components/mvtmortgageform/mvt-mortgageform.vue');
                    break;
                case 'mvtSearchSaveConfirm':
                    loader = import(/* webpackChunkName: "dlg.tpls.searchsaveconfirm" */ '@/common/components/mvtsearchsaveconfirm/mvt-searchsaveconfirm.vue');
                    break;
                case 'mvtSendEmail':
                    loader = import(/* webpackChunkName: "dlg.tpls.sendemail" */ '@/common/components/mvtsendemail/mvt-sendemail.vue');
                    break;
                case 'mvtSellLead':
                    loader = import(/* webpackChunkName: "dlg.tpls.selllead" */ '@/common/components/mvtselllead/mvt-selllead.vue');
                    break;
                case 'mvtCashOffer':
                    loader = import(/* webpackChunkName: "dlg.tpls.cashoffer" */ '@/common/components/mvtcashoffer/mvt-cashoffer.vue');
                    break;
                case 'dppPopAvm':
                    loader = import(/* webpackChunkName: "dlg.tpls.popavm" */ '@/dpp/components/dpppop/dpp-popavm.vue');
                    break;
                case 'dppPopEst':
                    loader = import(/* webpackChunkName: "dlg.tpls.popest" */ '@/dpp/components/dpppop/dpp-popest.vue');
                    break;
                case 'equityMortgagePop':
                    loader = import(/* webpackChunkName: "dlg.tpls.popup" */ '@/homeowner/components/equitymortgagepopup/equity-mortgage-popup.vue');
                    break;
                case 'editProfile':
                    loader = import(/* webpackChunkName: "dlg.tpls.profile" */ '@/mymovoto/components/editprofile/edit-profile.vue');
                    break;
                case 'mortgageForm':
                    loader = import(/* webpackChunkName: "dlg.tpls.form" */ '@/homeowner/components/mortgageform/mortgage-form.vue');
                    break;
                case 'homeownerEditMortgage':
                    loader = import(/* webpackChunkName: "dlg.tpls.homeowner.mortgage" */ '@/homeowner/components/homeownermortgagedialog/homeowner-mortgage-dialog.vue');
                    break;
                case 'homeownerEditProperty':
                    loader = import(/* webpackChunkName: "dlg.tpls.homeowner.property" */ '@/homeowner/components/homeownerpropertydialog/homeowner-property-dialog.vue');
                    break;
                case 'homeownerRemoveProperty':
                    loader = import(/* webpackChunkName: "dlg.tpls.homeowner.remove" */ '@/homeowner/components/homeownerremovedialog/homeowner-remove-property-dialog.vue');
                    break;
                case 'homeownerEditCredit':
                    loader = import(/* webpackChunkName: "dlg.tpls.homeowner.credit" */ '@/homeowner/components/homeownercreditdialog/homeowner-credit-dialog.vue');
                    break;
                case 'homeownerEditIncome':
                    loader = import(/* webpackChunkName: "dlg.tpls.homeowner.income" */ '@/homeowner/components/homeownerincomedialog/homeowner-income-dialog.vue');
                    break;
                case 'homeownerEditVeteran':
                    loader = import(/* webpackChunkName: "dlg.tpls.homeowner.veteran" */ '@/homeowner/components/homeownerveterandialog/homeowner-veteran-dialog.vue');
                    break;
                case 'resetPassword':
                    loader = import(/* webpackChunkName: "dlg.tpls.password" */ '@/mymovoto/components/password/reset-password.vue');
                    break;
                case 'forgotPassword':
                    loader = import(/* webpackChunkName: "dlg.tpls.password" */ '@/mymovoto/components/password/forgot-password.vue');
                    break;
                case 'editSavedSearch':
                    loader = import(/* webpackChunkName: "dlg.tpls.search" */ '@/mymovoto/components/editsavedsearch/edit-saved-search.vue');
                    break;
                case 'removeSavedSearch':
                    loader = import(/* webpackChunkName: "dlg.tpls.search" */ '@/mymovoto/components/removesavedsearch/remove-saved-search.vue');
                    break;
                case 'contactAgent':
                    loader = import(/* webpackChunkName: "dlg.tpls.agent" */ '@/msp/components/contactagent/contact-agent.vue');
                    break;
                case 'mvtConfirmCER':
                    loader = import(/* webpackChunkName: "dlg.tpls.confirmcer" */ '@/common/components/mvt-confirmcer/mvt-confirmcer.vue');
                    break;
                case 'unsubscribeConfirm':
                    loader = import(/* webpackChunkName: "dlg.tpls.confirm" */ '@/feed/components/unsubscribeconfirm/unsubscribe-confirm.vue');
                    break;
                case 'myConcierge':
                    loader = import(/* webpackChunkName: "dlg.tpls.mymvt.concierge" */ '@/mymovoto/components/agent/concierge/concierge.vue');
                    break;
                case 'myConcierge':
                    loader = import(/* webpackChunkName: "dlg.tpls.mymvt.feedback" */ '@/mymovoto/components/agent/agentfeedback/agent-feedback.vue');
                    break;
                case 'conciergeConfirm':
                    loader = import(/* webpackChunkName: "dlg.tpls.mymvt.confirm" */ '@/mymovoto/components/agent/conciergeconfirm/concierge-confirm.vue');
                    break;
                case 'favoritePR':
                    loader = import(/* webpackChunkName: "dlg.tpls.favoritepr" */ '@/dpp/components/propertyfavoritepr/property-favoritepr.vue');
                    break;
                case 'changeAgent':
                    loader = import(/* webpackChunkName: "dlg.tpls.agentselection" */ '@/dpp/components/dppagentselection/dpp-agentselection.vue');
                    break;
                case '3wayPayment':
                    loader = import(/* webpackChunkName: "dlg.tpls.mortgage" */ '@/dpp/components/propertymortgage/property-mortgage-dialog.vue');
                    break;
                case 'dppIframePop':
                    loader = import(/* webpackChunkName: "dlg.tpls.iframepop" */ '@/dpp/components/dppiframepop/dpp-iframepop.vue');
                    break;
                case 'mrcMortgageRates':
                    loader = import(/* webpackChunkName: "dlg.tpls.mortgagerates" */ '@/common/components/mvtmortgage/mrcmortgagerates/mrc-mortgagerates.vue');
                    break;
                case 'mvtConfirmSave':
                    loader = import(/* webpackChunkName: "dlg.tpls.confirmsave" */ '@/common/components/mvtconfirmsave/mvt-confirmsave.vue');
                    break;
                case 'checkListPros':
                    loader = import(/* webpackChunkName: "dlg.tpls.pros" */ '@/homeowner/components/checklistpros/checklist-pros.vue');
                    break;
                case 'mvtPostLeadFlow':
                    loader = import(/* webpackChunkName: "dlg.tpls.postleadflow" */ '@/common/components/mvtpostleadflow/mvt-post-lead-flow.vue');
                    break;
            }
            return { loader, callback };
        },
        showDialog(component, name, options, trigger) {
            if (timer) {
                clearTimeout(timer);
            }
            let opt = options || {};
            opt.trigger = trigger;
            if (trigger) {
                this.componentTrigger = trigger;
            } else {
                this.componentTrigger = this.$options.name;
            }
            this.componentOpt = opt;
            this.componentName = name;
            this.componentTemplate = component.template;
            component.callback && component.callback();
            if (this.$refs.dialog) {
                this.$refs.dialog.show(name, trigger, opt);
            } else {
                setTimeout(() => {
                    this.$refs.dialog.show(name, trigger, opt);
                }, 1000);
            }
        },
        show: async function (name, opt, trigger) {
            if (!this.dialogCache[name]) {
                this.showDialog({ template: 'loadingDialog' }, 'loadingDialog', { ...opt, enableClose: false }, trigger);
                // await yieldToMain();
                const { loader = null, callback } = this.getDialog(name);
                return (
                    loader &&
                    loader
                        .then((module) => {
                            this.dialogCache[name] = {
                                template: module.default,
                                callback,
                            };
                            return this.showDialog(this.dialogCache[name], name, opt, trigger);
                        })
                        .catch((e) => {
                            this.dlgRetryCount++;
                            opt && (opt.dlgRetryCount = this.dlgRetryCount);
                            window.sendNodeLog('dlgLazyFail', window.location.href, this.dlgRetryCount, {
                                tpl: name,
                                trigger: trigger,
                                message: e && e.message + ', stack:' + e.stack,
                                tid: this.glb.ip,
                                mid: this.glb.movotoDeviceID,
                            });
                            return this.showDialog({ template: 'loadDialogError' }, 'loadDialogError', opt, trigger);
                        })
                );
            }
            this.showDialog(this.dialogCache[name], name, opt, trigger);
        },
        hide() {
            this.componentName = '';
            this.componentOpt = {};
            this.componentTemplate = '';
            this.componentOpt.events && this.componentOpt.events.closed && this.componentOpt.events.closed();

            if (timer) {
                clearTimeout(timer);
            }
            timer = setTimeout(() => {
                this.afterLoginAndCloseDialog();
            }, 3000);
        },
        showMessage(message, isNewStyle, timeout = 1500) {
            this.message = message;
            this.isNewStyle = !!isNewStyle;
            this.showTip = true;
            if (tipTimer) {
                clearTimeout(tipTimer);
            }
            tipTimer = setTimeout(() => {
                this.hideMessage();
            }, timeout);
        },
        hideMessage() {
            this.showTip = false;
        },
        facebookLogin() {
            var listingId = window.addFavListingId || '';
            var propertyId = window.addFavPropertyId || '';
            this.$eventBus.$emit('eventbus-context-update');
            var url = location.origin + location.pathname;
            url = this.glb.appUrl + 'loginFacebookDialog/?returnUrl=' + encodeURIComponent(url) + '&listingId=' + listingId + '&propertyId=' + propertyId + '&userType=' + this.glb.pageInfo.userType;
            window.location.href = url;
        },
        appleLogin(trigger, requestName) {
            loadAppleAuth().then(() => {
                var parseJwtCode = function (code) {
                    let url = code.split('.')[1];
                    let data = url.replace(/-/g, '+').replace(/_/g, '/');
                    let jsonData = decodeURIComponent(
                        atob(data)
                            .split('')
                            .map(function (c) {
                                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
                            })
                            .join('')
                    );

                    return JSON.parse(jsonData);
                };

                document.addEventListener('AppleIDSignInOnSuccess', (data) => {
                    if (!data || !data.detail || !data.detail.authorization) {
                        return;
                    }
                    let appleData = {},
                        tokenData = parseJwtCode(data.detail.authorization.id_token);

                    appleData.idtoken = data.detail.authorization.id_token;
                    appleData.authorizationCode = data.detail.authorization.code;
                    appleData.email = tokenData.email;
                    appleData.socialid = tokenData.sub;
                    appleData.requesterType = 'CONSUMER_DT';

                    if (data.detail.user) {
                        appleData.name = data.detail.user.name.firstName + ' ' + data.detail.user.name.lastName;
                    }
                    appleData.trigger = getGa4Trigger(trigger, requestName);
                    appleData.userType = this.glb.pageInfo.userType;
                    this.loginForAppleAccount(appleData).then((res) => {
                        this.loginSuccess(res);
                    });
                });
                document.addEventListener('AppleIDSignInOnFailure', (error) => {});
                if (window.AppleID) {
                    window.AppleID.auth.init({
                        clientId: this.glb.appleLoginClientId,
                        scope: 'name email',
                        redirectURI: window.__INITIAL_STATE__.appUrl,
                        usePopup: true,
                    });
                    window.AppleID.auth.signIn();
                }
            });
        },
        loginSuccess(res) {
            if (res && res.status && res.status.code === 0 && res.data) {
                this.$eventBus.$emit('close-dialog', this.componentTrigger);
                this.$eventBus.$emit('eventbus-context-update');
                setTimeout(() => {
                    window.location.reload(true);
                }, 2000);
            }
        },
        show3rdPartyPop({
            id,
            url,
            zipcode,
            price,
            propertyType,
            pid,
            houseRealStatus,
            trigger,
            cta,
            isAutoPop,
            imageUrl,
            listingUrl,
            veteranTYPSplit,
            veteransType,
            isAppendUtmCta,
            isNoLenders,
            hotleadId,
        }) {
            const options = {
                triggerId: id || 'getquotes',
                trigger: trigger || '',
                zipcode: zipcode || this.glb.geo.zipcode || '',
                price: price || '',
                propertyType: propertyType || '',
                houseRealStatus: houseRealStatus || '',
                address: encodeURIComponent(this.glb.geo.address) || '',
                city: encodeURIComponent(this.glb.geo.city) || '',
                state: encodeURIComponent(this.glb.geo.state) || '',
                county: encodeURIComponent(this.glb.geo.county) || '',
                fullName: this.glb.hotleadInfo.fullName || this.glb.user.fullName || '',
                email: this.glb.hotleadInfo.email || this.glb.user.email || '',
                phone: this.glb.hotleadInfo.phone || this.glb.user.phone || '',
                url: url || '',
                pageType: this.glb.pageType || '',
                cta: cta || '',
                isAutoPop: isAutoPop || false,
                imageUrl: encodeURIComponent(imageUrl) || '',
                listingUrl: encodeURIComponent(listingUrl) || '',
                veteranTYPSplit: veteranTYPSplit || false,
                veteransType: veteransType || '',
                isNoLenders: isNoLenders || false,
                hotleadId: hotleadId || '',
                pid: pid,
                isAppendUtmCta: isAppendUtmCta,
                componentTrigger: this.componentTrigger,
            };
            options.phone = options.phone.replace(/[\D]/g, '');
            getOjolink().then(m => m.openBankratePop(options));
        },
        dialogAllClosed() {
            if (this.glb.authRedirectUrl) {
                if (this.glb.user && this.glb.user.id) {
                    window.location.href = this.glb.authRedirectUrl;
                } else {
                    this.glb.authRedirectUrl = '';
                }
            } else {
                let options = this.getPrevHotlead.options;
                if (options) {
                    if (options.redirectUrl) {
                        window.location = options.redirectUrl;
                    } else if (options.newUser) {
                        window.location.reload();
                    }
                }
            }
            this.resetPrevHotlead();
        },
        showConfirmPop() {
            this.$eventBus.$emit('dialog-center', {
                name: 'mvtConfirmAuth',
                opt: {},
                trigger: this.componentTrigger,
            });
        },
        openContact(payload) {
            this.$eventBus.$emit('dialog-center', {
                name: 'mvtHotleadForm',
                trigger: this.$options.name,
                opt: {
                    hotleadTitle: this.molang('common.ContactUs'),
                    hotleadType: this.glb.isMobile ? 'ContactMovotoMobile' : 'ContactMovotoDesktop',
                    buttonText: this.molang('common.send'),
                    showComment: true,
                    hideVeteran: true,
                    profileUrl: 'icon-envelope',
                    enquiryType: payload?.enquiryType,
                },
            });
        },
        openSchedulePop() {
            let hotleadOpt = {
                hotleadTitle: 'Meet an experienced local agent',
                hotleadSub: 'Talk to one of our expert agents,<br/> no obligation, just helpful advice.',
                hotleadType: 'ChatBotBuy',
                buttonText: 'Request Info',
                profileUrl: this.glb.cdnUrl + 'vimages/agent-headshot.png',
                showInterestOptions: true,
            };
            if (this.dpp && this.dpp.geo && this.dpp.geo.zipcode) {
                hotleadOpt.propertyData = this.dpp;
                hotleadOpt.zipcode = this.dpp.geo.zipcode;
            } else if (this.glb.geo && this.glb.geo.zipcode) {
                hotleadOpt.zipcode = this.glb.geo.zipcode;
            } else {
                hotleadOpt.showZipcode = true;
            }

            this.$eventBus.$emit('dialog-center', {
                name: 'mvtHotleadForm',
                trigger: this.componentTrigger,
                opt: hotleadOpt,
            });
        },
        popHotleadAfterAutenticated() {
            let hasSendHotlead = getStorage('hotleadCount') > 0;
            let autoPopAfterAuthenticated = getStorage('autoPopAfterAuthenticated');

            if (!autoPopAfterAuthenticated || hasSendHotlead) {
                return;
            }

            if (this.getSplit('movoto-CW-1073')) {
                if (this.glb.user && !this.glb.user.activated) {
                    this.openSchedulePop();
                }
            } else {
                this.openSchedulePop();
            }

            setTimeout(() => {
                setStorage('autoPopAfterAuthenticated', false);
            }, 3000);
            this.$eventBus.$once('eventbus-dialog-close', () => {
                setStorage('autoPopAfterAuthenticated', false);
            });
        },
        setRedirectUrl() {
            let url = window.location.href.split('#')[0];
            //get returnurl from current href
            let search = url.split('?')[1];
            //get value of returnurl
            let redirectUrl = window.location.origin + window.location.pathname;
            if (search) {
                let params = search.split('&');
                for (let i = 0; i < params.length; i++) {
                    let param = params[i].split('=');
                    if (/returnurl/i.test(param[0])) {
                        redirectUrl = decodeURIComponent(param[1]);
                        break;
                    }
                }
                if (redirectUrl) {
                    this.glb.authRedirectUrl = redirectUrl;
                }
            } else if (!this.glb.authRedirectUrl) {
                this.glb.authRedirectUrl = redirectUrl;
            }
        },
        hasRedirectedLogin() {
            if (!['vhome', 'vhomeowner'].includes(this.glb.pageType)) {
                return;
            }
            const qs = (this.$route && this.$route.query) || {};
            if (!qs.showlogin) {
                return;
            }
            const redirectUrl = qs.returnurl;
            if (String(qs.errorcode) === '1') {
                this.glb.authErrorMessage = 'Invalid or expired token';
            }
            if (this.glb.user.id) {
                redirectUrl && (location.href = redirectUrl);
            } else {
                this.show('mvtAuthenticate', { type: 'mvtLogin', redirectUrl }, this.glb.pageType);
            }
        },
    },
    mounted() {
        this.componentMounted = true;
        if (this.glb.pageType === 'vmapsearch' && !this.removeAds) {
            getOjolink().then(m => m.loadCmAds(this.glb.splits['movoto-cm-ads-wrapper-variant-CW-4620']));
        }
        this.hasRedirectedLogin();
        this.popHotleadAfterAutenticated();
        this.$eventBus.$on('eventbus-login-apple', this.appleLogin);
        this.$eventBus.$on('eventbus-login-facebook', this.facebookLogin);
        this.$eventBus.$on('eventbus-pop-3rdparty', this.show3rdPartyPop);
        this.$eventBus.$on('eventbus-submit-signup', ({ email, requestName, phone, name }) => this.signUpMixin(email, requestName, phone, name));
        this.$eventBus.$on('eventbus-show-confirm-pop', this.showConfirmPop);
        this.$eventBus.$on('eventbus-authenticated', (requestName) => {
            this.requestName = requestName;
            if (requestName !== 'simpledppclaim' && requestName !== 'addclaimhome') {
                let isRentalPage = (this.glb.pageType === 'vmapsearch' || this.glb.pageType === 'vdpp') && this.glb.rentals;

                if (isRentalPage) {
                    this.$eventBus.$emit('close-dialog', this.componentTrigger);
                } else {
                    setStorage('autoPopAfterAuthenticated', true);
                }
                this.popHotleadAfterAutenticated();
            }
            this.setRedirectUrl();
            this.afterLoginAndCloseDialog();
        });
        this.$eventBus.$on('eventbus-pop-schedule-lead', this.openSchedulePop);
        this.$eventBus.$on('dialog-open-contactus', this.openContact);
        // this.openSchedulePop();
    },
    beforeUnmount() {
        this.$eventBus.$off('dialog-center');
        this.$eventBus.$off('dialog-open-contactus', this.openContact);
    },
    beforeMount() {
        this.$eventBus.$on('dialog-center', (data) => {
            this.show(data.name, data.opt, data.trigger);
        });
        this.$eventBus.$on('dialog-center-tip', (message, isNewStyle, timeout) => {
            this.showMessage(message, isNewStyle, timeout);
        });
    },
};
